module.exports = __webpack_public_path__ + "img/login_img.ef446686.png";